module.exports = __webpack_public_path__ + "static/media/exclamation-outline.98d35686.svg";